module.exports = __webpack_public_path__ + "static/arataki-itto-selected-0e7fbbca07cb741ba7fd26ebb9181a6b.png";